function init_story_stream_sponsored(){

    console.log("story");
    var sp_url = decodeURIComponent(window.location.href).toLowerCase();
    var sp_topic_match = sp_url.match(/topic=(\w+)/);

    if(typeof sp_topic_match != 'undefined' && sp_topic_match.length > 0){

        var sp_topic = sp_topic_match.length >1 ? sp_topic_match[1] : "election_2016";

        var meta_url = "/topic/"+sp_topic.substring(0, 1)+"/"+sp_topic+"/tag_meta.json";

        $.ajax({
            dataType: 'json',
            url: meta_url,
            success: function(data) {
                var output = '';

                if(typeof data.tag_assigned_tags !== 'undefined' && data.tag_assigned_tags.length > 0){

                    $(document).ready(function(){
                        //overwrites the original height of the parent div to adjust to the new elements added

                        $(data.tag_assigned_tags).each(function(){
                            var safe_link = this.name.toLowerCase().replace(/ /g, '_').replace(/\W+/g, "");
                            //output += '<li class="tag-icon"><a href="/stream/?topic=' + this.name + '">'+ this.name +'</a></li>';
                            output += '<li class="tag-icon">';
                            output +=   '<div class="content_wrapper">';
                            output +=   '<a href=/stream/?topic=' + safe_link + '>' + this.name + '</a>';
                            output +=   '</div>'; //end of content-wrapper
                            output += '</li>'; //end item
                        });


                        story_stream_related_tags_html = '<div class="alpha_related_tags_mobile"><ul class="related-tags mobile"><span class="alpha_related_tags_title">Related Topics: </span>' + output + '</ul></div>';
                        //adds the description to the header
                        $('.tag-description').append(data.tag_description);

                        $('.related_tags').append('<div class="rec-widget-header"><div class="rec-title related-topics">Related Topics</div></div>');
                        $('.related_tags').append('<ul class="related-tags-side-widget"></ul>');
                        $('.related_tags ul.related-tags-side-widget').append(output);

                        if($('.alpha_related_tags').length) {
                            $('.alpha_related_tags').append(output);
                        }
                    });
                }

                if(parseInt(data.sponsored) == 1){

                    if(data.sponsor_ads != null || data.sponsor_ads != "" || data.sponsor_ads != undefined){

                        $("#jsSite").attr("data-gaTag", data.sponsor_ads);
                        GA_TAG = $("#jsSite").attr("data-gaTag");
                    }
                    //overwrites the ba


                    $('#sponsored_heading').html('<link type="text/css" rel="stylesheet" href="/asset/section/story-stream-sponsored.css" />');
                    setTimeout(function(){
                        $('#sponsored_heading').html('<link type="text/css" rel="stylesheet" href="/asset/section/story-stream-sponsored.css" />');
                        //console.log("delayed css");
                    }, 300);

                    $('.stream-details div.icon').html('<img src="/asset/img/storyStream-header-icon-black.png">');
                    setTimeout(function(){
                        $('.stream-details div.icon').html('<img src="/asset/img/storyStream-header-icon-black.png">');
                        //console.log("delayed icon");
                    }, 300);

                    $(document).ready(function(){

                        var html = "";
                        html += "<center>"+data.sponsor_text+"</center>";

                        if(data.sponsor_link != null || data.sponsor_link != "" || data.sponsor_link != undefined){
                            html += "<a href='"+data.sponsor_link+"'>";
                        }
                        html += "<center><img src='"+data.sponsor_img+"' class='sponsored_header_img'></center>";

                        if(data.sponsor_link !== null || data.sponsor_link !== "" || data.sponsor_link !== undefined){
                            html += "</a>";
                        }

                        $('#sponsored_heading').append(html);
                    });



                    setTimeout(function(){
                        $('#sponsored_heading').append(html);
                        //console.log("delayed append");
                    }, 400);
                    //console.log("Sponsored On");

                }else if(data.tag_image_loc !== '' || data.tag_image_loc !== null){
                    //console.log(data);

                    $(document).ready(function(){

                        $('.stream-header').css({
                            'background-color' : '#000',
                            'height' : '300px'
                        });

                        $('.stream-header .photo').css({
                            'background' : 'url('+data.tag_image_loc+') no-repeat #000',
                            'background-color' : '#000',
                            'opacity': '0.6',
                            'background-size' : 'cover',
                            'height': '300px',
                            'background-position-y' : '50%',
                        });


                        //$('.tag-description').append(data.tag_description);
                        $('.tag-description').css({
                            'color' : '#fff',
                        });
                    });

                    /*
        setTimeout(function(){
            $('.stream-header').css({
            'background-color' : '#000',
            });

            if(data.tag_image_loc !== '' || data.tag_image_loc !== null){
            $('.stream-header .photo').css({
                'background' : 'url('+data.tag_image_loc+') no-repeat #000',
                'background-color' : '#000',
                'opacity': '0.6',
                'background-size' : 'cover',
                'height': '250px',
                'background-position-y' : '50%',
            });
            }

            //$('.tag-description').append(data.tag_description);
            $('.tag-description').css({
            'color' : '#fff',
            });


        }, 500);
        */

                } else{
                    $(document).ready(function(){
                        $('.photo').css({
                            'background-color' : '#000',
                            'height' : '250px',
                        });
                    });

                    /*setTimeout(function(){
                        $('.photo').css('background', '#000');
                        //console.log("delayed else");
                        }, 500);*/
                    //console.log("Sponsored Off");
                }
            },
            error: function(jqXHR, textStatus, errorThrown){
                $('.photo').css('background', '#000');
                setTimeout(function(){
                    $('.photo').css('background', '#000');
                    //console.log("delayed error");
                }, 500);
            },
            statusCode: {
                404: function() {
                    //console.log( "sponsor json not found" );
                    $('.photo').css('background', '#000');
                    setTimeout(function(){
                        $('.photo').css('background', '#000');
                        //console.log("delayed 404");
                    }, 500);
                },
                403:function() {
                    //console.log( "sponsor json forbiden" );
                    $('.photo').css('background', '#000');
                    setTimeout(function(){
                        $('.photo').css('background', '#000');
                        //console.log("delayed 403");
                    }, 500);
                }
            }
        });
    }else{
        console.log('no topic for story stream');
    }

}

export default init_story_stream_sponsored;